<template>
    <alert-modal
        :title="title"
        :primaryCTAText="$t('ACTION_CLOSE')"
        :error="true"
        @close="close"
        @confirm="close"
    >
        <div class="cz2__modal-popup__copy">
            <div class="cz2__mb-25" v-html="$t('SAVE_ERROR_BODY')" />
        </div>
    </alert-modal>
</template>

<style lang="scss"></style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },
        computed: {
            title() {
                return this.$t('SAVE_ERROR_TITLE');
            },
        },
        methods: {
            close() {
                this.$store.dispatch('globalBusy', false);

                this.$store.dispatch('showSaveError', false);
            },
        },
    };
</script>
